import { Routes } from '@angular/router';
import { UserAccountComponent } from './user-account/user-account.component';

export const frameRoutes: Routes = [
  {
    path: 'user-account/:key',
    component: UserAccountComponent,
    data: {
      permissions: ['CustomerModule.Users:View']
    },
    children: []
  }
];



// WEBPACK FOOTER //
// ./src/app/frames/routes.config.ts